import React, { useState } from 'react';
import { Col, Modal, Row, Typography } from 'antd';
import { get } from 'lodash';

const { Text, Title } = Typography;

const PHOTOS = [
  { TITLE: 'NPWP', KEY: 'business_application.npwp_photo' },
  { TITLE: 'KTP', KEY: 'business_application.ktp_photo' },
  { TITLE: 'Selfie with KTP', KEY: 'business_application.selfie_ktp_photo' },
];

const Documents = ({ value }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});

  function onPreview(index) {
    setShowPreview(true);
    setPreviewData(PHOTOS[index]);
  }

  return (
    <>
      <Col className="section-container pd-reseller-detail-docs" span={24}>
        <div className=" inner-section">
          <Row className="summaryContent">
            <Col span={24}>
              <Title className="pageSubtitle" level={3}>
                Documents
              </Title>
            </Col>
            {PHOTOS.map((PHOTO, idx) => (
              <Col span={5} offset={idx ? 1 : 0} key={idx}>
                <Col span={24}>
                  <Text>{PHOTO.TITLE}</Text>
                </Col>
                <Col span={24}>
                  <img
                    alt=""
                    height="120"
                    onClick={onPreview.bind(this, idx)}
                    src={get(value, PHOTO.KEY, '')}
                    width="120"
                  />
                </Col>
              </Col>
            ))}
          </Row>
        </div>
      </Col>

      <Modal
        centered
        footer={null}
        onCancel={setShowPreview.bind(this, false)}
        title={previewData.TITLE}
        open={showPreview}
        wrapClassName="pd-reseller-modal">
        <img alt="" src={get(value, previewData.KEY, '')} />
      </Modal>
    </>
  );
};

export default Documents;
